import { useContext, useMemo } from 'react'
import { ReportPeriodContext } from '../../context/ReportPeriodContext'
import resolveWidgetPeriod from '../../../../../helpers/liveReportHelpers/resolveWidgetPeriod'
import periodRangeToDates from '../../../../../helpers/liveReportHelpers/periodRangeToDates'

// AI-CONTEXT: See docs/features/livereport2-period-selector.md
// Resolves a data widget's effective period from its own PeriodOverrideControl
// setting and the report's overall period (ReportPeriodContext). Centralised
// so the data widgets don't each repeat the context-read + resolve + convert
// chain. Pure logic lives in (tested) helpers; this hook only composes them.

/**
 * @param {{mode?: 'inherit'|'custom'|'all', start?: string|null, end?: string|null}|null|undefined} periodSetting - The widget's saved period setting
 * @returns {{range: {start: string|null, end: string|null}|null, startDate: Date|null, endDate: Date|null}}
 *   range: the resolved ISO range (null = no filter), for client-side row
 *   filtering (template mode). startDate/endDate: the same range as local
 *   Date bounds, for the live data layer.
 */
const useWidgetPeriod = (periodSetting) => {
    const reportPeriod = useContext(ReportPeriodContext)

    return useMemo(() => {
        const range = resolveWidgetPeriod(periodSetting, reportPeriod)
        const { startDate, endDate } = periodRangeToDates(range)
        return { range, startDate, endDate }
    }, [periodSetting, reportPeriod])
}

export default useWidgetPeriod
